<template>
	<div class="table_div">
		<el-form :inline="true" class="select_form" style="display: flex; align-items: center;">
			<el-form-item style='min-width:50px'>
				<h3>企业信息管理</h3>
			</el-form-item>
			<el-form-item>
				<el-button type='primary' @click="checkComInfo">企业信息</el-button>
			</el-form-item>
			<el-form-item>
				<el-cascader placeholder="请选择行业" filterable style="width: 200px" :options="infoData.industryDataList"
					v-model="infoData.industryName" :props="{ checkStrictly: true ,value:'text',label:'text'}" clearable
					@change='getTableData'>
				</el-cascader>
			</el-form-item>
			<el-form-item style="width: 140px">
				<el-select v-model="infoData.sortValue" placeholder="选择排序字段" clearable @change='getTableData'>
					<el-option v-for="item in infoData.options" :key="item.value" :label="item.label"
						:value="item.value" />
				</el-select>
			</el-form-item>
			<el-form-item style="width: 80px">
				<el-select v-model="infoData.orderValue" placeholder="顺序" clearable @change='getTableData'>
					<el-option v-for="item in infoData.orderOptions" :key="item.value" :label="item.label"
						:value="item.value" />
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-input v-model="infoData.searchInput" placeholder="请输入企业名称" clearable @change='getTableData'>
					<template #append>
						<el-button icon="Search" @click="getTableData" />
					</template>
				</el-input>
			</el-form-item>
		</el-form>
		<el-table :data="infoData.tableData" stripe border table-layout="fixed" @select="handleSelect" ref='tableData'
			highlight-current-row @current-change="handleTableChange" v-loading='infoData.loading' height='86%'>
			<el-table-column type="selection" width="55" />
			<el-table-column prop="name" label="单位名称" fixed width='260' />
			<el-table-column prop="lastName" label="曾用名" width='260' />
			<el-table-column prop="orgCode" label="信用代码" width='200' />
			<el-table-column prop="regionName" label="行政区划" sortable width='120' />
			<el-table-column prop="address" label="详细地址" width='300' sortable />
			<el-table-column prop="sCjy" label="生产经营" sortable width='260' />
			<el-table-column prop="lsgx" label="隶属关系" sortable width='140' />
			<el-table-column prop="industryFullPath" label="所属行业" sortable width='260' />
			<el-table-column prop="iso" label="ISO14001认证" sortable width='160' />
			<el-table-column prop="yjtx" label="预警体系" sortable width='140' />
			<el-table-column prop="qygw" label="企业官网" sortable width='140' />
			<el-table-column prop="scgm" label="生产规模" sortable width='180' />
			<el-table-column prop="workDay" label="年生产天数" sortable width='140'>
				<template #default="scope">
					<span v-if='scope.row.workDay'>{{scope.row.workDay}}天</span>
				</template>
			</el-table-column>
			<el-table-column prop="scgyml" label="生产工艺的名称" sortable width='180' />
			<el-table-column prop="gklx" label="管控类型" sortable width='140' />
			<el-table-column prop="styjzy" label="现有生态环境应急资源" sortable width='200' />
			<!-- <el-table-column prop="qysm" label="企业简介" sortable width='300' /> -->
			<el-table-column label="企业类型" width='100' fixed>
				<template #default="scope">
					<el-tag v-if="scope.row.hzqy == '是'">合资企业</el-tag>
					<el-tag v-if="scope.row.wzdq== '是'">外资企业</el-tag>

					<el-tag v-if="scope.row.ssgs== '是'" type="warning">上市公司</el-tag>
					<el-tag v-if="scope.row.cpck== '是'" type="info">产品出口</el-tag>

					<el-tag v-if="scope.row.isgq== '是'" type="success">国家企业</el-tag>
					<el-tag v-if="scope.row.isyq== '是'" type="success">中央企业</el-tag>
				</template>
			</el-table-column>
		</el-table>

		<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:current-page="infoData.pageInfo.pageIndex" :page-sizes="[20, 50, 100,200,500,1000]"
			:page-size="infoData.pageInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
			:total="infoData.pageInfo.totalRowCount" v-if='infoData.pageInfo.totalRowCount' class='pageinfo'>
		</el-pagination>
	</div>
</template>

<script>
	import {
		onMounted,
		reactive,
		ref
	} from "vue-demi";
	import api from "../../http/apis";
	import {
		ElMessageBox,
		ElMessage
	} from "element-plus";
	import {
		useStore
	} from "vuex";
	import {
		Search
	} from '@element-plus/icons-vue'
	export default {
		setup() {
			const store = useStore();
			const tableData = ref(null);
			const infoData = reactive({
				tableData: [],
				loading: false,
				pageInfo: {},
				searchInput: '',
				industryDataList: [],
				industryName: '',
				seletectInfo: {},
				options: [{
						label: '企业地址',
						value: 'address',
					},
					// {
					// 	label: '单位名称',
					// 	value: 'name',
					// },
					// {
					// 	label: '行政区划',
					// 	value: 'regionName',
					// }, 
					{
						label: 'iso认证',
						value: 'iso',
					}, {
						label: '所属行业',
						value: 'industryFullPath',
					},
					{
						label: '生产经营',
						value: 'sCjy',
					}, {
						label: '生产规模',
						value: 'scgm',
					}, {
						label: '管控类型',
						value: 'gklx',
					},
					{
						label: '隶属关系',
						value: 'lsgx',
					},
					{
						label: 'ISO14001认证',
						value: 'iso',
					},
					{
						label: '预警体系',
						value: 'yjtx',
					},
					{
						label: '年生产天数',
						value: 'workDay',
					},
					{
						label: '管控类型',
						value: 'gklx',
					},
					{
						label: '生产工艺的名称',
						value: 'scgyml',
					},
					{
						label: '企业简介',
						value: 'qysm',
					},

				],
				sortValue: '',
				orderValue: '',
				orderOptions: [{
						label: '升序',
						value: 'asc',
					},
					{
						label: '倒序',
						value: 'desc',
					},
				],
			});
			const getTableData = async () => {
				infoData.loading = true
				if (infoData.industryName) {
					var industryNameStr = ''
					infoData.industryName.forEach((item) => {
						industryNameStr = item
					})
				}
				const {
					data
				} = await api.companyApi.companyQuery({
					page: infoData.pageInfo.pageIndex || 1,
					rows: infoData.pageInfo.pageSize || 20,
					// address: infoData.searchInput,
					value: infoData.searchInput,
					industryFullPath: industryNameStr,
					registType: '',
					sort: infoData.sortValue,
					order: infoData.orderValue
				});
				if (data.isSuccessful) {
					infoData.loading = false
					infoData.tableData = data.resultObj.data
					infoData.pageInfo = data.resultObj.pagerInfo
				} else if (data.resultMsg) {
					ElMessage({
						message: data.resultMsg,
						type: "error",
					});
				} else {
					ElMessage({});
				}
			};
			getTableData()
			const getRegionList = async () => {
				const {
					data
				} = await api.companyApi.getManageToolMenu();
				if (data.isSuccessful) {
					infoData.regionDataList = data.resultObj
				} else if (data.resultMsg) {
					ElMessage({
						message: data.resultMsg,
						type: "error",
					});
				} else {
					ElMessage({});
				}
			};
			getRegionList()
			const getIndustryList = async () => {
				const {
					data
				} = await api.companyApi.getIndustryTree();
				if (data.isSuccessful) {
					infoData.industryDataList = data.resultObj
				} else if (data.resultMsg) {
					ElMessage({
						message: data.resultMsg,
						type: "error",
					});
				} else {
					ElMessage({});
				}
			};
			const handleSelect = (selection, row) => {
				if (selection.length > 1) {
					tableData.value.toggleRowSelection(selection[0], false)
					tableData.value.setCurrentRow(row)
					infoData.seletectInfo = row
				} else if (selection.length == 1) {
					tableData.value.setCurrentRow(row)
					infoData.seletectInfo = row
				} else if (selection == '') {
					tableData.value.toggleRowSelection(row, true)
					infoData.seletectInfo = row
				} else {
					infoData.seletectInfo = {}
				}
			};


			const handleTableChange = (currentRow, oldCurrentRow) => {
				if (oldCurrentRow) {
					tableData.value.toggleRowSelection(oldCurrentRow, false)
					handleSelect('', currentRow)
				} else {
					handleSelect('', currentRow)
				}

			};
			getIndustryList()
			return {
				infoData,
				getTableData,
				getRegionList,
				getIndustryList,
				handleSelect,
				handleTableChange,
				tableData
			};
		},
		methods: {
			checkComInfo() {
				if (this.infoData.seletectInfo.baseCompanyId) {
					this.$router.push({
						path: "/system/userTable/comInfo",
						query: {
							comId: this.infoData.seletectInfo.baseCompanyId,
						},
					});
				} else {
					ElMessage({
						message: '请先选中企业后再查看！',
						type: "error",
					});
				}
			},
			handleSizeChange(val) {
				this.infoData.pageInfo.pageSize = val;
				this.getTableData();
			},
			handleCurrentChange(val) {
				this.infoData.pageInfo.pageIndex = val;
				this.getTableData();
			},
			dateTrimmer(str) {
				if (str) {
					return str.slice(0, 10) + " " + str.slice(11, 19);
				} else {
					return "无";
				}
			},
		},
	};
</script>

<style scoped lang='scss'>
	@use "../../assets/scss/table.scss"as *;
</style>
